import { values } from './_helpers'

const _enum = {
  card: 0,
  bankTransfer: 1
}

const paymentType = { ..._enum, name: 'paymentType', values: values(_enum) }

export {
  paymentType
}
